import script from "./payment.vue?vue&type=script&setup=true&lang=js"
export * from "./payment.vue?vue&type=script&setup=true&lang=js"

import "./payment.vue?vue&type=style&index=0&id=55a4b957&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a4b957"]])

export default __exports__